import React from "react";
import { Container } from "react-bootstrap";
import "./Combined.css";
import Highlights from "../VideoHighlights/VideoHighlights";
import Memories from "../MemoryHighlight/MemoriesHighlight";

export default function Combined({links}) {

  return (
    <>
      <div className="combined-carousel">

        <div className="combined-heading">
          <div className="first-part pt-4 pb-5">Highlights From </div>
          <div className="second-part pt-4 pb-5">&nbsp;Prior Events</div>
        </div>
        <div className="carousel-section">
          <div className="highlights-section col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6">
            <Highlights />
          </div>
          <div className="memories-section col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6">
            <Memories />
          </div>
        </div>
        <Container>
          <div className="jason mt-4 mb-5 text-center">
            <p className="jasontxt">Jason Oppenheim is a paid spokesman for <a href="https://celligence.com/" target="_blank">Celligence International, LLC, </a>the creators of {links.current.brandName}. </p>
            <p className="jasontxt ivtext" >Ivan Rodriguez is a paid spokesperson for <a href="https://www.swmc.com/" target="_blank">Sun West Mortgage Company, Inc.</a></p>
          </div>
        </Container>
      </div>
    </>
  );
}
